var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSurvey = function SvgIcSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 10.9H1.8c-1 0-1.8-.8-1.8-1.8V1.8C0 .8.8 0 1.8 0h5.4c.6 0 1 .4 1 1s-.4 1-1 1H2v6.9h6.9v-.6c0-.6.4-1 1-1s1 .4 1 1v.8c0 1-.8 1.8-1.8 1.8zM22.3 24h-7.5c-.9 0-1.7-.8-1.7-1.7v-7.5c0-.9.8-1.7 1.7-1.7h7.5c.9 0 1.7.8 1.7 1.7v7.5c0 .9-.8 1.7-1.7 1.7zm-7.2-2H22v-6.9h-6.9V22zM18.6 10.9c-3 0-5.4-2.4-5.4-5.4S15.6 0 18.6 0 24 2.4 24 5.4s-2.4 5.5-5.4 5.5zm0-8.9c-1.9 0-3.4 1.5-3.4 3.4s1.5 3.4 3.4 3.4S22 7.3 22 5.4 20.5 2 18.6 2zM5.4 24c-3 0-5.4-2.4-5.4-5.4s2.4-5.4 5.4-5.4 5.4 2.4 5.4 5.4S8.4 24 5.4 24zm0-8.9c-1.9 0-3.4 1.5-3.4 3.4S3.5 22 5.4 22s3.4-1.5 3.4-3.4-1.5-3.5-3.4-3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 8c-.2 0-.5-.1-.7-.3L4 5.9c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l1 1L10.1 1c.4-.4 1-.5 1.4-.1s.5 1 .1 1.4L7.2 7.7c-.2.2-.4.3-.8.3.1 0 .1 0 0 0z"
  })));
};
export default SvgIcSurvey;